import { authHttp } from '../http'
import * as routes from '../../routes/deliveries.routes'
import { errorHandler } from '../../../util/error.service'
import { getUsuarioInfo } from '../../../localstorage/localstorage.service'
import { parseToMysqlFormat } from '../../../util/date.service'

export async function getFrotasParaEnvio(tp_id, user_id, pInicial, pFinal) {
  try {
    const { id } = getUsuarioInfo()
    const response = await authHttp().get(
      routes.urlGetFrotasParaEnvio(
        tp_id,
        user_id || id,
        pInicial ? parseToMysqlFormat(pInicial) : undefined,
        pFinal ? parseToMysqlFormat(pFinal) : undefined,
      ),
    )
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function putFleetObservation(fleet_id, observation) {
  try {
    const response = await authHttp().put(routes.urlPutFleetObservation(), {
      fleet_id,
      observation,
    })

    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function getEnviosParaFrota(tp_id, vehicle_badge, expected_date) {
  try {
    const response = await authHttp().get(
      routes.urlGetEnviosParaFrota(tp_id, vehicle_badge, expected_date),
    )
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function postRoutesDistance(tp_id, waypoints) {
  try {
    const response = await authHttp().post(routes.urlPostRoutesDistance(tp_id), { waypoints })
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function setLoadOrder(deliveries) {
  try {
    const response = await authHttp().put(routes.urlSetDeliveryLoadOrder(), deliveries)
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function alterarVeiculoMotorista(fleet_id, fleetInfo) {
  try {
    const response = await authHttp().put(routes.urlPutAlterarVeiculoMotorista(fleet_id), fleetInfo)
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function alterarCarregamentoEmPosicoes(fleet_id, carregamento_em_posicoes) {
  try {
    const response = await authHttp().put(routes.urlPutCarregamentoEmPosicoesFleet(fleet_id), {
      carregamento_em_posicoes,
    })
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function descarregarDeliveries(associacoes_ids) {
  try {
    const { id: user_id } = getUsuarioInfo()
    const response = await authHttp().put(
      routes.urlPutDescarregarDeliveries(user_id),
      associacoes_ids,
    )
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function enviarParaRota(associacoes_ids) {
  try {
    const { id: user_id } = getUsuarioInfo()
    const response = await authHttp().put(
      routes.urlPutEnviarFrotaParaRota(user_id, parseToMysqlFormat(new Date())),
      associacoes_ids,
    )
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function getTotalProdutosVeiculos(tp_id, fleet_ids) {
  try {
    const response = await authHttp().get(routes.urlGetTotalProdutosVeiculos(tp_id, fleet_ids))
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function cancelarMapaEmitido(fleet_ids) {
  try {
    const { id: user_id } = getUsuarioInfo()
    const response = await authHttp().post(routes.urlPostCancelarMapaEmitido(user_id), {
      fleet_ids,
    })
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}
